/**
 * Wraps hover styles inside `@media (hover: hover) and (pointer: fine)` so
 * that touch-only devices never apply :hover styles that would get "stuck"
 * after a tap.  Use for CSS-only hover effects (no runtime state needed).
 * Keep useMediaQuery('(hover: hover) and (pointer: fine)') for cases where
 * the hover condition controls a JS render decision (e.g. popovers).
 *
 * Usage:
 *   sx={{ ...hoverable({ bgcolor: 'action.hover' }) }}
 */
export const hoverable = (hoverStyles) => ({
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': hoverStyles,
  },
});
